/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EfectivizarTransferenciaExternaME { 
    usuarioId?: string | null;
    nombreOrdenante?: string | null;
    numeroCuentaOrigen?: string | null;
    codigoConcepto?: string | null;
    tipoIdentificacionDescripcion?: string | null;
    identificacion?: string | null;
    nombreApellido?: string | null;
    codigoTipoInstitucion?: string | null;
    correoBeneficiario?: string | null;
    telefonoBeneficiario?: string | null;
    codigoTipoCuenta?: string | null;
    numeroCuentaDestino?: string | null;
    detalle?: string | null;
    codigoUsuarioBanca?: string | null;
    identificacionOrigen?: string | null;
    otp?: string | null;
    valor?: number;
    esDesdeMovil?: boolean;
    origenFondos?: string | null;
  secuencialInstitucion?: number | null;
  esDirecto?: boolean;
  omiteOTP?: boolean;
  agregaContacto?:boolean
}
